import React, { useEffect, useState } from "react";
import axios from "axios";

import Header from "./Components/Header";
import Footer from "./Components/Footer";
import About from "./Components/About";
import Resume from "./Components/Resume";
import Contact from "./Components/Contact";
import Testimonials from "./Components/Testimonials";
import Portfolio from "./Components/Portfolio";

import "./App.css";

const App = () => {
	const [resumeData, setResumeData] = useState({});
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		setLoading(true);
		axios
			.get("https://xodeeq.pythonanywhere.com/profile/1/")
			.then((res) => {
				console.log("res", res.data);
				setResumeData(res.data);
				setLoading(false);
			})
			.catch((error) => {
				console.log(error);
				setError(error.message || "Failed to load data from server");
				setLoading(false);
			});
	}, []);

	// Reinitialize waypoints after React renders all sections
	useEffect(() => {
		if (!loading && resumeData && window.jQuery) {
			// Wait for React to finish rendering all components
			setTimeout(() => {
				const $ = window.jQuery;
				const sections = $("section");
				const navigation_links = $("#nav-wrap a");

				// Destroy existing waypoints if any
				if (sections.length > 0) {
					sections.each(function () {
						if (this.waypoint) {
							$(this).waypoint('destroy');
						}
					});

					// Reinitialize waypoints
					sections.waypoint({
						handler: function (event, direction) {
							var active_section;
							active_section = $(this);
							if (direction === "up") active_section = active_section.prev();

							var active_link = $('#nav-wrap a[href="#' + active_section.attr("id") + '"]');

							navigation_links.parent().removeClass("current");
							active_link.parent().addClass("current");
						},
						offset: '35%'
					});
				}
			}, 300);
		}
	}, [loading, resumeData]);

	if (loading) {
		return (
			<div className='App' style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				fontSize: '1.5rem'
			}}>
				Loading...
			</div>
		);
	}

	if (error) {
		return (
			<div className='App' style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: '100vh',
				fontSize: '1.5rem',
				color: 'red'
			}}>
				Error: {error}
			</div>
		);
	}

	return (
		<div className='App'>
			<Header data={resumeData} />
			<About data={resumeData} />
			<Resume data={resumeData.resume} />
			<Portfolio data={resumeData.portfolio} />
			<Testimonials data={resumeData.testimonials} />
			<Contact data={resumeData} />
			<Footer data={resumeData} />
		</div>
	);
};

export default App;
